import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";
import { Spinner } from "@fluentui/react-components";

import { getAccessToken, getAgentsPresence } from "../../Services/GraphServices";
import AgentRow from "./AgentRow";
import "./CSS/AgentsComponent.css";

const AgentsComponent = ({ 
  tenantId, 
  agents,
  isLoading,
  connection,
  isConnected
}) => {
  const { t } = useTranslation();
  const { instance, accounts } = useMsal();
  const activeAccount = accounts[0];
  const [agentsData, setAgentsData] = useState([]);
  const [agentPresences, setAgentPresences] = useState({});

  // Utiliser le vrai tenantId de l'utilisateur
  const realTenantId = activeAccount?.tenantId || tenantId;

  // Utiliser directement les agents concaténés passés en prop
  useEffect(() => {
    if (!agents || agents.length === 0) {
      setAgentsData([]);
      return;
    }
    setAgentsData(agents);
  }, [agents]);

  // Récupérer et mettre à jour la présence des agents toutes les 5 secondes
  useEffect(() => {
    if (!agentsData || agentsData.length === 0 || !instance || !activeAccount) return;

    const fetchPresences = async () => {
      try {
        const token = await getAccessToken(instance, activeAccount);
        const userIds = agentsData
          .map(agent => agent.userId || agent.id || agent.email)
          .filter(Boolean);

        if (userIds.length === 0) return;

        const response = await getAgentsPresence(userIds, token);
        
        const presencesArray = response?.value || response || [];
        
        if (presencesArray && Array.isArray(presencesArray)) {
          const presenceMap = {};
          presencesArray.forEach(presence => {
            if (presence.id && presence.availability) {
              presenceMap[presence.id] = {
                availability: presence.availability,
                activity: presence.activity,
              };
            }
          });
          setAgentPresences(presenceMap);
        }
      } catch (error) {
        console.error("Error loading agent presences:", error);
      }
    };

    fetchPresences();
    const interval = setInterval(fetchPresences, 5000);

    return () => clearInterval(interval);
  }, [agentsData, instance, activeAccount]);

  return (
    <div className="agents-wrapper">
      {/* Column Headers */}
      <div className="agents-columns-header">
        <div className="agents-column-header">
          <div className="agents-header-info">{t("REALTIME.AGENT")}</div>
          <div className="agents-header-stats">
            <div className="agents-header-stat">{t("REALTIME.CALLS_IN_PROGRESS")}</div>
            <div className="agents-header-stat">{t("REALTIME.CALLS_MISSED")}</div>
            <div className="agents-header-stat">{t("REALTIME.TOTAL_CALLS")}</div>
            <div className="agents-header-stat">{t("REALTIME.DURATION_OF_CALLS")}</div>
          </div>
        </div>
        <div className="agents-column-header agents-column-header-2">
          <div className="agents-header-info">{t("REALTIME.AGENT")}</div>
          <div className="agents-header-stats">
            <div className="agents-header-stat">{t("REALTIME.CALLS_IN_PROGRESS")}</div>
            <div className="agents-header-stat">{t("REALTIME.CALLS_MISSED")}</div>
            <div className="agents-header-stat">{t("REALTIME.TOTAL_CALLS")}</div>
            <div className="agents-header-stat">{t("REALTIME.DURATION_OF_CALLS")}</div>
          </div>
        </div>
      </div>

      {/* Agents List */}
      <div className="agents-component-list">
        {agentsData.map(agent => {
          const lookupId = agent.userId || agent.id;
          const agentPresence = agentPresences[lookupId];
          
          return (
            <AgentRow
              key={agent.id}
              agent={agent}
              tenantId={realTenantId}
              agentPresence={agentPresence}
              connection={connection}
              isConnected={isConnected}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AgentsComponent;
